import {tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetPageNamePageUseCase extends UseCase {
  constructor({log, service}) {
    super({log, service})

    this._log = log
    this._service = service
  }

  @tracer({metric: 'GetPageNamePageUseCase#execute'})
  async execute({path}) {
    return this._service.execute({path})
  }
}
